var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdsButton',_vm._g(_vm._b({attrs:{"buttonText":"Cancel","tertiary":""}},'AdsButton',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }